import useFeature from "../data/useFeatureFlag";
import { useNavigate } from "react-router-dom";
import useStructureParams from "../lib/useStructureParams";
import { LoadingSpinner } from "./spinners";

interface props {
  enabledId: string;
  page: any;
}

const UrlEnabled = ({ enabledId, page }: props) => {
  //check if feature is enabled
  const { loading, feature } = useFeature(enabledId);

  //navigate to summary page if feature is not disabled
  const navigate = useNavigate();

  const { code, type } = useStructureParams();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (feature?.enabled === true) {
    return page;
  } else {
    return navigate(`/${type}/${code}`);
  }
};

export default UrlEnabled;
